export interface Position {
  x: number;
  y: number;
}

export type UrlParam = { id: string };

export type CountryCodeType = {
  mask: string;
  country: string;
  countryCode: string;
  numberLength: number;
  flag: string;
};

export const countryPhoneCodes: CountryCodeType[] = [
  {
    mask: '(+1)',
    country: 'United States',
    countryCode: 'US',
    numberLength: 10,
    flag: '🇺🇸',
  },
  {
    mask: '(+93)',
    country: 'Afghanistan',
    countryCode: 'AF',
    numberLength: 9,
    flag: '🇦🇫',
  },
  {
    mask: '(+355)',
    country: 'Albania',
    countryCode: 'AL',
    numberLength: 9,
    flag: '🇦🇱',
  },
  {
    mask: '(+213)',
    country: 'Algeria',
    countryCode: 'DZ',
    numberLength: 10,
    flag: '🇩🇿',
  },
  {
    mask: '(+376)',
    country: 'Andorra',
    countryCode: 'AD',
    numberLength: 6,
    flag: '🇦🇩',
  },
  {
    mask: '(+244)',
    country: 'Angola',
    countryCode: 'AO',
    numberLength: 9,
    flag: '🇦🇴',
  },
  {
    mask: '(+54)',
    country: 'Argentina',
    countryCode: 'AR',
    numberLength: 10,
    flag: '🇦🇷',
  },
  {
    mask: '(+374)',
    country: 'Armenia',
    countryCode: 'AM',
    numberLength: 8,
    flag: '🇦🇲',
  },
  {
    mask: '(+61)',
    country: 'Australia',
    countryCode: 'AU',
    numberLength: 9,
    flag: '🇦🇺',
  },
  {
    mask: '(+43)',
    country: 'Austria',
    countryCode: 'AT',
    numberLength: 10,
    flag: '🇦🇹',
  },
  {
    mask: '(+994)',
    country: 'Azerbaijan',
    countryCode: 'AZ',
    numberLength: 9,
    flag: '🇦🇿',
  },
  {
    mask: '(+973)',
    country: 'Bahrain',
    countryCode: 'BH',
    numberLength: 8,
    flag: '🇧🇭',
  },
  {
    mask: '(+880)',
    country: 'Bangladesh',
    countryCode: 'BD',
    numberLength: 10,
    flag: '🇧🇩',
  },
  {
    mask: '(+375)',
    country: 'Belarus',
    countryCode: 'BY',
    numberLength: 9,
    flag: '🇧🇾',
  },
  {
    mask: '(+32)',
    country: 'Belgium',
    countryCode: 'BE',
    numberLength: 9,
    flag: '🇧🇪',
  },
  {
    mask: '(+501)',
    country: 'Belize',
    countryCode: 'BZ',
    numberLength: 7,
    flag: '🇧🇿',
  },
  {
    mask: '(+229)',
    country: 'Benin',
    countryCode: 'BJ',
    numberLength: 8,
    flag: '🇧🇯',
  },
  {
    mask: '(+975)',
    country: 'Bhutan',
    countryCode: 'BT',
    numberLength: 8,
    flag: '🇧🇹',
  },
  {
    mask: '(+591)',
    country: 'Bolivia',
    countryCode: 'BO',
    numberLength: 8,
    flag: '🇧🇴',
  },
  {
    mask: '(+387)',
    country: 'Bosnia and Herzegovina',
    countryCode: 'BA',
    numberLength: 8,
    flag: '🇧🇦',
  },
  {
    mask: '(+267)',
    country: 'Botswana',
    countryCode: 'BW',
    numberLength: 8,
    flag: '🇧🇼',
  },
  {
    mask: '(+55)',
    country: 'Brazil',
    countryCode: 'BR',
    numberLength: 11,
    flag: '🇧🇷',
  },
  {
    mask: '(+673)',
    country: 'Brunei',
    countryCode: 'BN',
    numberLength: 7,
    flag: '🇧🇳',
  },
  {
    mask: '(+359)',
    country: 'Bulgaria',
    countryCode: 'BG',
    numberLength: 9,
    flag: '🇧🇬',
  },
  {
    mask: '(+226)',
    country: 'Burkina Faso',
    countryCode: 'BF',
    numberLength: 8,
    flag: '🇧🇫',
  },
  {
    mask: '(+257)',
    country: 'Burundi',
    countryCode: 'BI',
    numberLength: 8,
    flag: '🇧🇮',
  },
  {
    mask: '(+855)',
    country: 'Cambodia',
    countryCode: 'KH',
    numberLength: 9,
    flag: '🇰🇭',
  },
  {
    mask: '(+237)',
    country: 'Cameroon',
    countryCode: 'CM',
    numberLength: 9,
    flag: '🇨🇲',
  },
  {
    mask: '(+1)',
    country: 'Canada',
    countryCode: 'CA',
    numberLength: 10,
    flag: '🇨🇦',
  },
  {
    mask: '(+238)',
    country: 'Cape Verde',
    countryCode: 'CV',
    numberLength: 7,
    flag: '🇨🇻',
  },
  {
    mask: '(+236)',
    country: 'Central African Republic',
    countryCode: 'CF',
    numberLength: 8,
    flag: '🇨🇫',
  },
  {
    mask: '(+235)',
    country: 'Chad',
    countryCode: 'TD',
    numberLength: 8,
    flag: '🇹🇩',
  },
  {
    mask: '(+56)',
    country: 'Chile',
    countryCode: 'CL',
    numberLength: 9,
    flag: '🇨🇱',
  },
  {
    mask: '(+86)',
    country: 'China',
    countryCode: 'CN',
    numberLength: 11,
    flag: '🇨🇳',
  },
  {
    mask: '(+57)',
    country: 'Colombia',
    countryCode: 'CO',
    numberLength: 10,
    flag: '🇨🇴',
  },
  {
    mask: '(+269)',
    country: 'Comoros',
    countryCode: 'KM',
    numberLength: 7,
    flag: '🇰🇲',
  },
  {
    mask: '(+506)',
    country: 'Costa Rica',
    countryCode: 'CR',
    numberLength: 8,
    flag: '🇨🇷',
  },
  {
    mask: '(+385)',
    country: 'Croatia',
    countryCode: 'HR',
    numberLength: 9,
    flag: '🇭🇷',
  },
  {
    mask: '(+53)',
    country: 'Cuba',
    countryCode: 'CU',
    numberLength: 8,
    flag: '🇨🇺',
  },
  {
    mask: '(+357)',
    country: 'Cyprus',
    countryCode: 'CY',
    numberLength: 8,
    flag: '🇨🇾',
  },
  {
    mask: '(+420)',
    country: 'Czech Republic',
    countryCode: 'CZ',
    numberLength: 9,
    flag: '🇨🇿',
  },
  {
    mask: '(+243)',
    country: 'Democratic Republic of the Congo',
    countryCode: 'CD',
    numberLength: 9,
    flag: '🇨🇩',
  },
  {
    mask: '(+45)',
    country: 'Denmark',
    countryCode: 'DK',
    numberLength: 8,
    flag: '🇩🇰',
  },
  {
    mask: '(+253)',
    country: 'Djibouti',
    countryCode: 'DJ',
    numberLength: 8,
    flag: '🇩🇯',
  },
  {
    mask: '(+1)',
    country: 'Dominica',
    countryCode: 'DM',
    numberLength: 10,
    flag: '🇩🇲',
  },
  {
    mask: '(+1)',
    country: 'Dominican Republic',
    countryCode: 'DO',
    numberLength: 10,
    flag: '🇩🇴',
  },
  {
    mask: '(+593)',
    country: 'Ecuador',
    countryCode: 'EC',
    numberLength: 9,
    flag: '🇪🇨',
  },
  {
    mask: '(+20)',
    country: 'Egypt',
    countryCode: 'EG',
    numberLength: 10,
    flag: '🇪🇬',
  },
  {
    mask: '(+503)',
    country: 'El Salvador',
    countryCode: 'SV',
    numberLength: 8,
    flag: '🇸🇻',
  },
  {
    mask: '(+240)',
    country: 'Equatorial Guinea',
    countryCode: 'GQ',
    numberLength: 8,
    flag: '🇬🇶',
  },
  {
    mask: '(+291)',
    country: 'Eritrea',
    countryCode: 'ER',
    numberLength: 7,
    flag: '🇪🇷',
  },
  {
    mask: '(+372)',
    country: 'Estonia',
    countryCode: 'EE',
    numberLength: 7,
    flag: '🇪🇪',
  },
  {
    mask: '(+251)',
    country: 'Ethiopia',
    countryCode: 'ET',
    numberLength: 9,
    flag: '🇪🇹',
  },
  {
    mask: '(+298)',
    country: 'Faroe Islands',
    countryCode: 'FO',
    numberLength: 6,
    flag: '🇫🇴',
  },
  {
    mask: '(+679)',
    country: 'Fiji',
    countryCode: 'FJ',
    numberLength: 7,
    flag: '🇫🇯',
  },
  {
    mask: '(+358)',
    country: 'Finland',
    countryCode: 'FI',
    numberLength: 10,
    flag: '🇫🇮',
  },
  {
    mask: '(+33)',
    country: 'France',
    countryCode: 'FR',
    numberLength: 9,
    flag: '🇫🇷',
  },
  {
    mask: '(+241)',
    country: 'Gabon',
    countryCode: 'GA',
    numberLength: 8,
    flag: '🇬🇦',
  },
  {
    mask: '(+220)',
    country: 'Gambia',
    countryCode: 'GM',
    numberLength: 7,
    flag: '🇬🇲',
  },
  {
    mask: '(+995)',
    country: 'Georgia',
    countryCode: 'GE',
    numberLength: 9,
    flag: '🇬🇪',
  },
  {
    mask: '(+49)',
    country: 'Germany',
    countryCode: 'DE',
    numberLength: 11,
    flag: '🇩🇪',
  },
  {
    mask: '(+233)',
    country: 'Ghana',
    countryCode: 'GH',
    numberLength: 9,
    flag: '🇬🇭',
  },
  {
    mask: '(+30)',
    country: 'Greece',
    countryCode: 'GR',
    numberLength: 10,
    flag: '🇬🇷',
  },
  {
    mask: '(+299)',
    country: 'Greenland',
    countryCode: 'GL',
    numberLength: 6,
    flag: '🇬🇱',
  },
  {
    mask: '(+1)',
    country: 'Grenada',
    countryCode: 'GD',
    numberLength: 10,
    flag: '🇬🇩',
  },
  {
    mask: '(+502)',
    country: 'Guatemala',
    countryCode: 'GT',
    numberLength: 8,
    flag: '🇬🇹',
  },
  {
    mask: '(+224)',
    country: 'Guinea',
    countryCode: 'GN',
    numberLength: 8,
    flag: '🇬🇳',
  },
  {
    mask: '(+245)',
    country: 'Guinea-Bissau',
    countryCode: 'GW',
    numberLength: 7,
    flag: '🇬🇼',
  },
  {
    mask: '(+592)',
    country: 'Guyana',
    countryCode: 'GY',
    numberLength: 7,
    flag: '🇬🇾',
  },
  {
    mask: '(+509)',
    country: 'Haiti',
    countryCode: 'HT',
    numberLength: 8,
    flag: '🇭🇹',
  },
  {
    mask: '(+504)',
    country: 'Honduras',
    countryCode: 'HN',
    numberLength: 8,
    flag: '🇭🇳',
  },
  {
    mask: '(+852)',
    country: 'Hong Kong',
    countryCode: 'HK',
    numberLength: 8,
    flag: '🇭🇰',
  },
  {
    mask: '(+36)',
    country: 'Hungary',
    countryCode: 'HU',
    numberLength: 9,
    flag: '🇭🇺',
  },
  {
    mask: '(+354)',
    country: 'Iceland',
    countryCode: 'IS',
    numberLength: 7,
    flag: '🇮🇸',
  },
  {
    mask: '(+91)',
    country: 'India',
    countryCode: 'IN',
    numberLength: 10,
    flag: '🇮🇳',
  },
  {
    mask: '(+62)',
    country: 'Indonesia',
    countryCode: 'ID',
    numberLength: 11,
    flag: '🇮🇩',
  },
  {
    mask: '(+98)',
    country: 'Iran',
    countryCode: 'IR',
    numberLength: 10,
    flag: '🇮🇷',
  },
  {
    mask: '(+964)',
    country: 'Iraq',
    countryCode: 'IQ',
    numberLength: 10,
    flag: '🇮🇶',
  },
  {
    mask: '(+353)',
    country: 'Ireland',
    countryCode: 'IE',
    numberLength: 9,
    flag: '🇮🇪',
  },
  {
    mask: '(+972)',
    country: 'Israel',
    countryCode: 'IL',
    numberLength: 9,
    flag: '🇮🇱',
  },
  {
    mask: '(+39)',
    country: 'Italy',
    countryCode: 'IT',
    numberLength: 10,
    flag: '🇮🇹',
  },
  {
    mask: '(+225)',
    country: 'Ivory Coast',
    countryCode: 'CI',
    numberLength: 8,
    flag: '🇨🇮',
  },
  {
    mask: '(+1)',
    country: 'Jamaica',
    countryCode: 'JM',
    numberLength: 10,
    flag: '🇯🇲',
  },
  {
    mask: '(+81)',
    country: 'Japan',
    countryCode: 'JP',
    numberLength: 10,
    flag: '🇯🇵',
  },
  {
    mask: '(+962)',
    country: 'Jordan',
    countryCode: 'JO',
    numberLength: 9,
    flag: '🇯🇴',
  },
  {
    mask: '(+7)',
    country: 'Kazakhstan',
    countryCode: 'KZ',
    numberLength: 10,
    flag: '🇰🇿',
  },
  {
    mask: '(+254)',
    country: 'Kenya',
    countryCode: 'KE',
    numberLength: 9,
    flag: '🇰🇪',
  },
  {
    mask: '(+686)',
    country: 'Kiribati',
    countryCode: 'KI',
    numberLength: 7,
    flag: '🇰🇮',
  },
  {
    mask: '(+965)',
    country: 'Kuwait',
    countryCode: 'KW',
    numberLength: 8,
    flag: '🇰🇼',
  },
  {
    mask: '(+996)',
    country: 'Kyrgyzstan',
    countryCode: 'KG',
    numberLength: 9,
    flag: '🇰🇬',
  },
  {
    mask: '(+856)',
    country: 'Laos',
    countryCode: 'LA',
    numberLength: 8,
    flag: '🇱🇦',
  },
  {
    mask: '(+371)',
    country: 'Latvia',
    countryCode: 'LV',
    numberLength: 8,
    flag: '🇱🇻',
  },
  {
    mask: '(+961)',
    country: 'Lebanon',
    countryCode: 'LB',
    numberLength: 8,
    flag: '🇱🇧',
  },
  {
    mask: '(+266)',
    country: 'Lesotho',
    countryCode: 'LS',
    numberLength: 8,
    flag: '🇱🇸',
  },
  {
    mask: '(+231)',
    country: 'Liberia',
    countryCode: 'LR',
    numberLength: 7,
    flag: '🇱🇷',
  },
  {
    mask: '(+218)',
    country: 'Libya',
    countryCode: 'LY',
    numberLength: 9,
    flag: '🇱🇾',
  },
  {
    mask: '(+423)',
    country: 'Liechtenstein',
    countryCode: 'LI',
    numberLength: 7,
    flag: '🇱🇮',
  },
  {
    mask: '(+370)',
    country: 'Lithuania',
    countryCode: 'LT',
    numberLength: 8,
    flag: '🇱🇹',
  },
  {
    mask: '(+352)',
    country: 'Luxembourg',
    countryCode: 'LU',
    numberLength: 8,
    flag: '🇱🇺',
  },
  {
    mask: '(+853)',
    country: 'Macau',
    countryCode: 'MO',
    numberLength: 8,
    flag: '🇲🇴',
  },
  {
    mask: '(+389)',
    country: 'Macedonia',
    countryCode: 'MK',
    numberLength: 8,
    flag: '🇲🇰',
  },
  {
    mask: '(+261)',
    country: 'Madagascar',
    countryCode: 'MG',
    numberLength: 9,
    flag: '🇲🇬',
  },
  {
    mask: '(+265)',
    country: 'Malawi',
    countryCode: 'MW',
    numberLength: 9,
    flag: '🇲🇼',
  },
  {
    mask: '(+60)',
    country: 'Malaysia',
    countryCode: 'MY',
    numberLength: 10,
    flag: '🇲🇾',
  },
  {
    mask: '(+960)',
    country: 'Maldives',
    countryCode: 'MV',
    numberLength: 7,
    flag: '🇲🇻',
  },
  {
    mask: '(+223)',
    country: 'Mali',
    countryCode: 'ML',
    numberLength: 8,
    flag: '🇲🇱',
  },
  {
    mask: '(+356)',
    country: 'Malta',
    countryCode: 'MT',
    numberLength: 8,
    flag: '🇲🇹',
  },
  {
    mask: '(+692)',
    country: 'Marshall Islands',
    countryCode: 'MH',
    numberLength: 7,
    flag: '🇲🇭',
  },
  {
    mask: '(+222)',
    country: 'Mauritania',
    countryCode: 'MR',
    numberLength: 8,
    flag: '🇲🇷',
  },
  {
    mask: '(+230)',
    country: 'Mauritius',
    countryCode: 'MU',
    numberLength: 7,
    flag: '🇲🇺',
  },
  {
    mask: '(+52)',
    country: 'Mexico',
    countryCode: 'MX',
    numberLength: 10,
    flag: '🇲🇽',
  },
  {
    mask: '(+691)',
    country: 'Micronesia',
    countryCode: 'FM',
    numberLength: 7,
    flag: '🇫🇲',
  },
  {
    mask: '(+373)',
    country: 'Moldova',
    countryCode: 'MD',
    numberLength: 8,
    flag: '🇲🇩',
  },
  {
    mask: '(+377)',
    country: 'Monaco',
    countryCode: 'MC',
    numberLength: 8,
    flag: '🇲🇨',
  },
  {
    mask: '(+976)',
    country: 'Mongolia',
    countryCode: 'MN',
    numberLength: 8,
    flag: '🇲🇳',
  },
  {
    mask: '(+382)',
    country: 'Montenegro',
    countryCode: 'ME',
    numberLength: 8,
    flag: '🇲🇪',
  },
  {
    mask: '(+212)',
    country: 'Morocco',
    countryCode: 'MA',
    numberLength: 9,
    flag: '🇲🇦',
  },
  {
    mask: '(+258)',
    country: 'Mozambique',
    countryCode: 'MZ',
    numberLength: 9,
    flag: '🇲🇿',
  },
  {
    mask: '(+95)',
    country: 'Myanmar',
    countryCode: 'MM',
    numberLength: 9,
    flag: '🇲🇲',
  },
  {
    mask: '(+264)',
    country: 'Namibia',
    countryCode: 'NA',
    numberLength: 9,
    flag: '🇳🇦',
  },
  {
    mask: '(+674)',
    country: 'Nauru',
    countryCode: 'NR',
    numberLength: 7,
    flag: '🇳🇷',
  },
  {
    mask: '(+977)',
    country: 'Nepal',
    countryCode: 'NP',
    numberLength: 10,
    flag: '🇳🇵',
  },
  {
    mask: '(+31)',
    country: 'Netherlands',
    countryCode: 'NL',
    numberLength: 10,
    flag: '🇳🇱',
  },
  {
    mask: '(+64)',
    country: 'New Zealand',
    countryCode: 'NZ',
    numberLength: 9,
    flag: '🇳🇿',
  },
  {
    mask: '(+505)',
    country: 'Nicaragua',
    countryCode: 'NI',
    numberLength: 8,
    flag: '🇳🇮',
  },
  {
    mask: '(+227)',
    country: 'Niger',
    countryCode: 'NE',
    numberLength: 8,
    flag: '🇳🇪',
  },
  {
    mask: '(+234)',
    country: 'Nigeria',
    countryCode: 'NG',
    numberLength: 10,
    flag: '🇳🇬',
  },
  {
    mask: '(+850)',
    country: 'North Korea',
    countryCode: 'KP',
    numberLength: 8,
    flag: '🇰🇵',
  },
  {
    mask: '(+47)',
    country: 'Norway',
    countryCode: 'NO',
    numberLength: 8,
    flag: '🇳🇴',
  },
  {
    mask: '(+968)',
    country: 'Oman',
    countryCode: 'OM',
    numberLength: 8,
    flag: '🇴🇲',
  },
  {
    mask: '(+92)',
    country: 'Pakistan',
    countryCode: 'PK',
    numberLength: 10,
    flag: '🇵🇰',
  },
  {
    mask: '(+680)',
    country: 'Palau',
    countryCode: 'PW',
    numberLength: 7,
    flag: '🇵🇼',
  },
  {
    mask: '(+970)',
    country: 'Palestine',
    countryCode: 'PS',
    numberLength: 9,
    flag: '🇵🇸',
  },
  {
    mask: '(+507)',
    country: 'Panama',
    countryCode: 'PA',
    numberLength: 8,
    flag: '🇵🇦',
  },
  {
    mask: '(+675)',
    country: 'Papua New Guinea',
    countryCode: 'PG',
    numberLength: 7,
    flag: '🇵🇬',
  },
  {
    mask: '(+595)',
    country: 'Paraguay',
    countryCode: 'PY',
    numberLength: 9,
    flag: '🇵🇾',
  },
  {
    mask: '(+51)',
    country: 'Peru',
    countryCode: 'PE',
    numberLength: 9,
    flag: '🇵🇪',
  },
  {
    mask: '(+63)',
    country: 'Philippines',
    countryCode: 'PH',
    numberLength: 10,
    flag: '🇵🇭',
  },
  {
    mask: '(+48)',
    country: 'Poland',
    countryCode: 'PL',
    numberLength: 9,
    flag: '🇵🇱',
  },
  {
    mask: '(+351)',
    country: 'Portugal',
    countryCode: 'PT',
    numberLength: 9,
    flag: '🇵🇹',
  },
  {
    mask: '(+974)',
    country: 'Qatar',
    countryCode: 'QA',
    numberLength: 8,
    flag: '🇶🇦',
  },
  {
    mask: '(+242)',
    country: 'Republic of the Congo',
    countryCode: 'CG',
    numberLength: 9,
    flag: '🇨🇬',
  },
  {
    mask: '(+40)',
    country: 'Romania',
    countryCode: 'RO',
    numberLength: 9,
    flag: '🇷🇴',
  },
  {
    mask: '(+7)',
    country: 'Russia',
    countryCode: 'RU',
    numberLength: 10,
    flag: '🇷🇺',
  },
  {
    mask: '(+250)',
    country: 'Rwanda',
    countryCode: 'RW',
    numberLength: 9,
    flag: '🇷🇼',
  },
  {
    mask: '(+590)',
    country: 'Saint Barthelemy',
    countryCode: 'BL',
    numberLength: 9,
    flag: '🇧🇱',
  },
  {
    mask: '(+290)',
    country: 'Saint Helena',
    countryCode: 'SH',
    numberLength: 5,
    flag: '🇸🇭',
  },
  {
    mask: '(+1)',
    country: 'Saint Kitts and Nevis',
    countryCode: 'KN',
    numberLength: 10,
    flag: '🇰🇳',
  },
  {
    mask: '(+1)',
    country: 'Saint Lucia',
    countryCode: 'LC',
    numberLength: 10,
    flag: '🇱🇨',
  },
  {
    mask: '(+590)',
    country: 'Saint Martin',
    countryCode: 'MF',
    numberLength: 9,
    flag: '🇲🇫',
  },
  {
    mask: '(+508)',
    country: 'Saint Pierre and Miquelon',
    countryCode: 'PM',
    numberLength: 6,
    flag: '🇵🇲',
  },
  {
    mask: '(+1)',
    country: 'Saint Vincent and the Grenadines',
    countryCode: 'VC',
    numberLength: 10,
    flag: '🇻🇨',
  },
  {
    mask: '(+685)',
    country: 'Samoa',
    countryCode: 'WS',
    numberLength: 7,
    flag: '🇼🇸',
  },
  {
    mask: '(+378)',
    country: 'San Marino',
    countryCode: 'SM',
    numberLength: 10,
    flag: '🇸🇲',
  },
  {
    mask: '(+239)',
    country: 'Sao Tome and Principe',
    countryCode: 'ST',
    numberLength: 7,
    flag: '🇸🇹',
  },
  {
    mask: '(+966)',
    country: 'Saudi Arabia',
    countryCode: 'SA',
    numberLength: 9,
    flag: '🇸🇦',
  },
  {
    mask: '(+221)',
    country: 'Senegal',
    countryCode: 'SN',
    numberLength: 9,
    flag: '🇸🇳',
  },
  {
    mask: '(+381)',
    country: 'Serbia',
    countryCode: 'RS',
    numberLength: 9,
    flag: '🇷🇸',
  },
  {
    mask: '(+248)',
    country: 'Seychelles',
    countryCode: 'SC',
    numberLength: 7,
    flag: '🇸🇨',
  },
  {
    mask: '(+232)',
    country: 'Sierra Leone',
    countryCode: 'SL',
    numberLength: 8,
    flag: '🇸🇱',
  },
  {
    mask: '(+65)',
    country: 'Singapore',
    countryCode: 'SG',
    numberLength: 8,
    flag: '🇸🇬',
  },
  {
    mask: '(+421)',
    country: 'Slovakia',
    countryCode: 'SK',
    numberLength: 9,
    flag: '🇸🇰',
  },
  {
    mask: '(+386)',
    country: 'Slovenia',
    countryCode: 'SI',
    numberLength: 9,
    flag: '🇸🇮',
  },
  {
    mask: '(+677)',
    country: 'Solomon Islands',
    countryCode: 'SB',
    numberLength: 7,
    flag: '🇸🇧',
  },
  {
    mask: '(+252)',
    country: 'Somalia',
    countryCode: 'SO',
    numberLength: 8,
    flag: '🇸🇴',
  },
  {
    mask: '(+27)',
    country: 'South Africa',
    countryCode: 'ZA',
    numberLength: 9,
    flag: '🇿🇦',
  },
  {
    mask: '(+82)',
    country: 'South Korea',
    countryCode: 'KR',
    numberLength: 10,
    flag: '🇰🇷',
  },
  {
    mask: '(+211)',
    country: 'South Sudan',
    countryCode: 'SS',
    numberLength: 9,
    flag: '🇸🇸',
  },
  {
    mask: '(+34)',
    country: 'Spain',
    countryCode: 'ES',
    numberLength: 9,
    flag: '🇪🇸',
  },
  {
    mask: '(+94)',
    country: 'Sri Lanka',
    countryCode: 'LK',
    numberLength: 9,
    flag: '🇱🇰',
  },
  {
    mask: '(+249)',
    country: 'Sudan',
    countryCode: 'SD',
    numberLength: 9,
    flag: '🇸🇩',
  },
  {
    mask: '(+597)',
    country: 'Suriname',
    countryCode: 'SR',
    numberLength: 7,
    flag: '🇸🇷',
  },
  {
    mask: '(+268)',
    country: 'Swaziland',
    countryCode: 'SZ',
    numberLength: 8,
    flag: '🇸🇿',
  },
  {
    mask: '(+46)',
    country: 'Sweden',
    countryCode: 'SE',
    numberLength: 9,
    flag: '🇸🇪',
  },
  {
    mask: '(+41)',
    country: 'Switzerland',
    countryCode: 'CH',
    numberLength: 9,
    flag: '🇨🇭',
  },
  {
    mask: '(+963)',
    country: 'Syria',
    countryCode: 'SY',
    numberLength: 9,
    flag: '🇸🇾',
  },
  {
    mask: '(+886)',
    country: 'Taiwan',
    countryCode: 'TW',
    numberLength: 9,
    flag: '🇹🇼',
  },
  {
    mask: '(+992)',
    country: 'Tajikistan',
    countryCode: 'TJ',
    numberLength: 9,
    flag: '🇹🇯',
  },
  {
    mask: '(+255)',
    country: 'Tanzania',
    countryCode: 'TZ',
    numberLength: 10,
    flag: '🇹🇿',
  },
  {
    mask: '(+66)',
    country: 'Thailand',
    countryCode: 'TH',
    numberLength: 9,
    flag: '🇹🇭',
  },
  {
    mask: '(+670)',
    country: 'Timor-Leste',
    countryCode: 'TL',
    numberLength: 7,
    flag: '🇹🇱',
  },
  {
    mask: '(+228)',
    country: 'Togo',
    countryCode: 'TG',
    numberLength: 8,
    flag: '🇹🇬',
  },
  {
    mask: '(+676)',
    country: 'Tonga',
    countryCode: 'TO',
    numberLength: 5,
    flag: '🇹🇴',
  },
  {
    mask: '(+1)',
    country: 'Trinidad and Tobago',
    countryCode: 'TT',
    numberLength: 10,
    flag: '🇹🇹',
  },
  {
    mask: '(+216)',
    country: 'Tunisia',
    countryCode: 'TN',
    numberLength: 8,
    flag: '🇹🇳',
  },
  {
    mask: '(+90)',
    country: 'Turkey',
    countryCode: 'TR',
    numberLength: 10,
    flag: '🇹🇷',
  },
  {
    mask: '(+993)',
    country: 'Turkmenistan',
    countryCode: 'TM',
    numberLength: 8,
    flag: '🇹🇲',
  },
  {
    mask: '(+688)',
    country: 'Tuvalu',
    countryCode: 'TV',
    numberLength: 5,
    flag: '🇹🇻',
  },
  {
    mask: '(+256)',
    country: 'Uganda',
    countryCode: 'UG',
    numberLength: 9,
    flag: '🇺🇬',
  },
  {
    mask: '(+380)',
    country: 'Ukraine',
    countryCode: 'UA',
    numberLength: 9,
    flag: '🇺🇦',
  },
  {
    mask: '(+971)',
    country: 'United Arab Emirates',
    countryCode: 'AE',
    numberLength: 9,
    flag: '🇦🇪',
  },
  {
    mask: '(+44)',
    country: 'United Kingdom',
    countryCode: 'GB',
    numberLength: 10,
    flag: '🇬🇧',
  },
  {
    mask: '(+598)',
    country: 'Uruguay',
    countryCode: 'UY',
    numberLength: 8,
    flag: '🇺🇾',
  },
  {
    mask: '(+998)',
    country: 'Uzbekistan',
    countryCode: 'UZ',
    numberLength: 9,
    flag: '🇺🇿',
  },
  {
    mask: '(+678)',
    country: 'Vanuatu',
    countryCode: 'VU',
    numberLength: 7,
    flag: '🇻🇺',
  },
  {
    mask: '(+39)',
    country: 'Vatican City',
    countryCode: 'VA',
    numberLength: 10,
    flag: '🇻🇦',
  },
  {
    mask: '(+58)',
    country: 'Venezuela',
    countryCode: 'VE',
    numberLength: 10,
    flag: '🇻🇪',
  },
  {
    mask: '(+84)',
    country: 'Vietnam',
    countryCode: 'VN',
    numberLength: 10,
    flag: '🇻🇳',
  },
  {
    mask: '(+967)',
    country: 'Yemen',
    countryCode: 'YE',
    numberLength: 9,
    flag: '🇾🇪',
  },
  {
    mask: '(+260)',
    country: 'Zambia',
    countryCode: 'ZM',
    numberLength: 9,
    flag: '🇿🇲',
  },
  {
    mask: '(+263)',
    country: 'Zimbabwe',
    countryCode: 'ZW',
    numberLength: 9,
    flag: '🇿🇼',
  },
];
